export default __webpack_public_path__ + "static/jspl-sol-953e2d51a162fa02fd94f52a1327b292.jpg";